import type { TFunction } from "i18next";
import type { TemplateContentDto } from "../../../../../../autogen/bff-api";
import type { TemplateSection } from "../../../../../../common/library/templateFromEvent";
import type { ProcurementTerms } from "../../../../../../common/terminology/useProcurementTerms";

const awardPart = (content: TemplateContentDto, t: TFunction, terms: ProcurementTerms): string | null => {
  if (content.awardCriteria?.lowestPrice) return t("Lowest price");

  const criteria = content.awardCriteria?.bestPriceQualityRatio?.criteria ?? [];
  if (criteria.length === 0) return null;

  const subCount = criteria.reduce((sum, c) => sum + (c.subCriteria?.length ?? 0), 0);
  const criteriaPart = terms.awardCriteriaCount(criteria.length);
  return subCount === 0
    ? criteriaPart
    : `${criteriaPart} (${t("{{count}} sub-criterion", { count: subCount })})`;
};

export const appliedSummary = (
  content: TemplateContentDto,
  order: TemplateSection[],
  t: TFunction,
  terms: ProcurementTerms
): string => {
  const part = (section: TemplateSection): string | null => {
    switch (section) {
      case "minimum": {
        const count = content.minimumRequirements?.length ?? 0;
        return count === 0 ? null : t("{{count}} minimum requirements", { count });
      }
      case "selection": {
        const count = content.selectionCriteria?.length ?? 0;
        return count === 0 ? null : t("{{count}} qualification requirements", { count });
      }
      case "award":
        return awardPart(content, t, terms);
    }
  };

  return order.flatMap((section) => part(section) ?? []).join(" · ");
};
